import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=301906e4&scoped=true&"
import script from "./purchaseDetail.vue?vue&type=script&lang=js&"
export * from "./purchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=301906e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301906e4",
  null
  
)

export default component.exports